/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 24/03/2006
'- Description : Gestion d'une file fifo.
'-----------------------------------------------------------------------------------------*/


export class IwsFifo {

    _array: Array<IwsControle>;

    constructor() {
        this._array = [];
    }

    // ajoute un element a la file
    public put(v: IwsControle) {
        this._array.unshift(v);
    }

    // indique si la file est vide
    public empty() {
        return (this._array.length <= 0);
    }

    // recupere le prochaine element de la file
    public get(): IwsControle {
        return this._array.pop();
    }

    public peek() {
        return this._array[this._array.length - 1];
    }

}


